import React, { useCallback, useContext, useEffect, useRef, useState, } from 'react';
import classnames from 'classnames';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import CloseThin from '@wix/da-ds/pkg/Icons/generated/components/CloseThin';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { BiData, } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import s from './SearchModal.scss';
var USERNAME_REGEX = /^[A-Za-z0-9][A-Za-z0-9-]{1,18}[A-Za-z0-9]$/;
var SearchModal = function (_a) {
    var onClose = _a.onClose, searchQuery = _a.searchQuery, isLegacyHeader = _a.isLegacyHeader;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useState(searchQuery !== null && searchQuery !== void 0 ? searchQuery : ''), inputValue = _b[0], setInputValue = _b[1];
    var logBiEvent = useBiLogger();
    var searchInputRef = useRef(null);
    var handleChange = useCallback(function (value) {
        setInputValue(value);
    }, []);
    var handleSubmit = useCallback(function (e) {
        var _a, _b;
        e.preventDefault();
        var searchTerm = (_b = (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim();
        if (!searchTerm) {
            return; // dont allow empty search
        }
        var searchUrl = Url.searchLink(searchTerm);
        var username = searchTerm.slice(1);
        var isCorrectUsername = searchTerm.startsWith('@') && USERNAME_REGEX.test(username);
        logBiEvent(BiData({
            evid: 710,
            search_terms: searchTerm,
            sectionname: 'popup',
        }));
        // Only search usernames if we are not on subdomain!
        if (isCorrectUsername && !isLegacyHeader) {
            var userLinkUrl_1 = Url.userLink(username);
            // to test this locally do `.replace('.com', '.lan')`
            var http = new XMLHttpRequest();
            http.open('HEAD', userLinkUrl_1);
            http.onreadystatechange = function () {
                if (this.readyState === this.DONE) {
                    var doesUserExists = this.status === 200;
                    var redirectUrl = doesUserExists ? userLinkUrl_1 : searchUrl;
                    window.location.assign(redirectUrl);
                }
            };
            http.send();
        }
        else {
            window.location.assign(searchUrl);
        }
    }, [isLegacyHeader, logBiEvent]);
    var handleInputKeyDown = useCallback(function (event) {
        if (event.key === 'Enter' || event.key === 'Return') {
            event.preventDefault();
            event.stopPropagation();
            handleSubmit(event);
        }
    }, [handleSubmit]);
    useEffect(function () {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);
    return (React.createElement(Modal, { overlayClassName: s['search-popup'], className: classnames(s['search-popup-content'], s['updated-inputs']), shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, onRequestClose: onClose, isOpen: true },
        React.createElement("div", null,
            React.createElement("div", { className: s['search-popup-form'], onClick: function (e) { return e.stopPropagation(); } },
                React.createElement("form", { className: s['search-form'], action: Url.searchLink(), onSubmit: handleSubmit },
                    React.createElement(TextInput, { ref: searchInputRef, id: "search-input", label: t('siteHeader.searchBar.placeholder'), placeholder: t('siteHeader.searchBar.placeholder'), value: inputValue, onChange: function (e) { return handleChange(e.target.value); }, onKeyDown: handleInputKeyDown, postfix: React.createElement(PlainButtonOrLink, { onClick: handleSubmit, biData: inputValue.length === 0
                                ? BiData({
                                    evid: 700,
                                    link_name: 'search',
                                })
                                : undefined },
                            React.createElement(SearchIcon, { disableDefaultColors: true })), className: s['search-popup-input'], noBottomSpacing: true, isLabelHidden: true, autoFocus: true, biData: BiData({
                            evid: 700,
                            link_name: 'search',
                        }) })),
                React.createElement("button", { className: s['search-popup-close-button'], onClick: onClose },
                    React.createElement(CloseThin, null))),
            isMobile && (React.createElement("div", { className: s['search-suggestions'] },
                React.createElement("h3", null, t('siteHeader.search.suggestions')),
                [
                    'Photography',
                    'Body Art',
                    'Artisan Designers',
                    'Fashion',
                    'Literature',
                ].map(function (i) { return (React.createElement("a", { key: i, href: Url.searchLink(i.toLowerCase()) }, i)); }))))));
};
SearchModal.displayName = 'SearchModal';
export default SearchModal;
//# sourceMappingURL=SearchModal.js.map